<template>
  <Modal
    v-if="isOpen"
    :isOpen="true"
    :changeModalState="closeModal"
    :modalTitle="`${$t('panel.warning_details') || 'Warning details'}`"
  >
    <div v-if="warning" class="space-y-5">
      <div class="flex items-start gap-3 rounded-lg bg-amber-50 text-amber-700 p-4">
        <span class="text-2xl leading-none">⚠️</span>
        <div class="space-y-1">
          <p class="text-base font-semibold">
            {{ $t('panel.warning_details') || 'Warning details' }}
          </p>
          <p class="text-sm text-amber-800">
            {{ $te('panel.latest_warning_description') ? $t('panel.latest_warning_description') : 'Recent warning logged for this store.' }}
          </p>
        </div>
      </div>
      <div class="rounded-lg border border-gray-100 p-4 shadow-sm space-y-5">
        <div class="grid gap-4 md:grid-cols-2">
          <div>
            <p class="text-xs uppercase tracking-wide text-gray-500">{{ $t('general.store_name') }}</p>
            <p class="text-lg font-semibold text-gray-900">{{ storeName || '—' }}</p>
          </div>
        </div>
        <div class="grid gap-4 md:grid-cols-3">
          <div class="space-y-1">
            <p class="text-xs uppercase tracking-wide text-gray-500">{{ $t('general.type') }}</p>
            <span class="inline-flex items-center rounded-full bg-amber-100 px-3 py-1 text-sm font-medium text-amber-700">
              {{ getWarningTypeLabel(warning?.type) }}
            </span>
          </div>
          <div class="space-y-1">
            <p class="text-xs uppercase tracking-wide text-gray-500">{{ $t('general.warning_status') }}</p>
            <span class="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-sm font-medium text-gray-700">
              {{ getWarningStatusLabel(warning?.status) }}
            </span>
          </div>
          <div class="space-y-1">
            <p class="text-xs uppercase tracking-wide text-gray-500">{{ $t('general.warning_creation_date') }}</p>
            <p class="text-sm font-medium text-gray-900">
              {{ warning?.creation_date || '—' }}
            </p>
          </div>
        </div>
        <div class="space-y-2">
          <p class="text-xs uppercase tracking-wide text-gray-500">{{ $t('general.reason') }}</p>
          <p class="text-gray-900 whitespace-pre-line leading-relaxed bg-gray-50 border border-gray-100 rounded-lg p-3">
            {{ warning?.reason || '—' }}
          </p>
        </div>
        <div v-if="warning?.reply" class="space-y-2">
          <p class="text-xs uppercase tracking-wide text-gray-500">{{ $t('general.reseller_reply') }}</p>
          <p class="text-gray-900 whitespace-pre-line leading-relaxed bg-gray-50 border border-gray-100 rounded-lg p-3">
            {{ warning?.reply }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex justify-center items-center gap-3 p-3 border-t rounded-t dark:border-gray-600">
      <button
        @click="closeModal"
        type="button"
        class="text-primary bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary/20 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2 hover:text-primary/90 focus:z-10"
      >
        {{ $t('general.ok') }}
      </button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from "@/components";

export default {
  name: "StoreWarningModal",
  components: {
    Modal,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Object,
      default: null,
    },
    storeName: {
      type: String,
      default: "",
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    getWarningTypeLabel(type) {
      const normalizedType = (type || "").toString().toLowerCase();
      switch (normalizedType) {
        case "first":
          return this.$t("general.first_warning");
        case "second":
          return this.$t("general.second_warning");
        case "third":
          return this.$t("general.third_warning");
        default:
          return type || "—";
      }
    },
    getWarningStatusLabel(status) {
      const normalizedStatus = (status || "").toString().toLowerCase();
      switch (normalizedStatus) {
        case "active":
          return this.$t("general.active") || "Active";
        case "resolved":
          return this.$t("general.resolved") || "Resolved";
        case "pending":
          return this.$t("general.pending") || "Pending";
        default:
          return status || "—";
      }
    },
  },
};
</script>

